export default "__VITE_ASSET__ZgNzNQEu__"